import { FC } from "react";

import { m } from "@recobra/i18n/messages";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  SidebarProvider,
} from "@recobra/ui/sidebar";
import { Skeleton } from "@recobra/ui/skeleton";
import { TooltipProvider } from "@recobra/ui/tooltip";

import { PageContentFallback } from "./PageContentFallback";

const AUTH_NAV_SKELETON_COUNT = 3;

export const AuthFallback: FC = () => (
  <TooltipProvider>
    <SidebarProvider>
      <div aria-busy="true" aria-label={m.loading_session()} className="contents">
        <span className="sr-only">{m.loading_session()}…</span>
        <Sidebar collapsible="icon">
          <SidebarHeader>
            <SidebarMenu>
              <SidebarMenuItem>
                <div className="flex h-12 items-center gap-2 px-2">
                  <Skeleton className="size-8 rounded-lg" />
                  <Skeleton className="h-4 w-24 group-data-[collapsible=icon]:hidden" />
                </div>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupLabel>
                <Skeleton className="h-3 w-20" />
              </SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {Array.from({ length: AUTH_NAV_SKELETON_COUNT }, (_, i) => (
                    <SidebarMenuItem key={i}>
                      <SidebarMenuSkeleton showIcon />
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
          <SidebarFooter>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuSkeleton showIcon className="h-12" />
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarFooter>
        </Sidebar>
        <SidebarInset>
          <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
            <Skeleton className="size-7" />
          </header>
          <main className="flex flex-1 flex-col gap-4 p-4">
            <PageContentFallback />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  </TooltipProvider>
);
